<template>
  <div class="pub-page">
    <div class="pub-header">
      <text class="title">{{$route.meta.title}}</text>
    </div>
    <div class="pub-center">
      <div class="shadow-sm bg-white px-3 py-2 my-1 d-flex align-items-center justify-content-center">

        <el-form :disabled="!isSupperAdmin" v-loading="loading" :rules="rules" :model="form" size="large" label-width="auto" style="width: 100%;max-width: 800px" ref="ruleFormRef">
          <el-row :gutter="10">
            <el-col :span="24" >
              <el-form-item label="大赛名称：" prop="name" >
                <el-input v-model="form.name"/>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="大赛logo：" prop="logo" >
                <el-upload
                    v-model:file-list="fileList"
                    :headers="uploadData"
                    :action="VUE_APP_uploadurl"
                    list-type="picture-card"
                    :limit="1"
                    :on-exceed="handleUploadExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    accept="image/png, image/jpeg"
                >
                  <el-icon>
                    <Plus/>
                  </el-icon>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="注册时间：" prop="Time" >
                <el-date-picker
                    v-model="form.Time"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="YYYY-MM-DD HH:mm:ss"
                    date-format="YYYY-MM-DD ddd"
                    value-format ="YYYY-MM-DD HH:mm:ss"
                    time-format="A hh:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="复赛文件提交时间：" prop="Time" >
                <el-date-picker
                    v-model="form.finalTime"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="YYYY-MM-DD HH:mm:ss"
                    date-format="YYYY-MM-DD ddd"
                    value-format ="YYYY-MM-DD HH:mm:ss"
                    time-format="A hh:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="作品提交截止时间：" prop="upload_end" >
                <el-date-picker
                    v-model="form.upload_end"
                    type="datetime"
                    placeholder="请选择"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format ="YYYY-MM-DD HH:mm:ss"
                    date-format="MMM DD, YYYY"
                    time-format="HH:mm"
                />
              </el-form-item>
            </el-col>
          </el-row>


          <div class="w-100  d-flex align-items-center justify-content-center flex-column my-4">
            <div>
              <el-button type="primary" class="px-5"
                         v-loading="saveLoading"
                         @click="save(ruleFormRef)"
              >保存
              </el-button>
              <el-button type="" class="px-5"
                         @click="getInfo"
              >重置
              </el-button>
            </div>
            <div class="small text-secondary mt-3">截止时间为作品最终提交时间</div>
          </div>
        </el-form>

      </div>
    </div>

  </div>

  <el-dialog v-model="dialogVisible">
    <img w-full :src="dialogImageUrl" alt="Preview Image" />
  </el-dialog>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";
import { Plus } from '@element-plus/icons-vue'
import {getToken} from "@/utils/token";
import {validateForm} from "@/utils/formValidate";
import {getSettings, updateAllSettings} from "@/api/settingAdmin";
import {formatTime} from "@/utils/dateFun";
import {useStore} from 'vuex'
const store = useStore()
const VUE_APP_uploadurl = process.env.VUE_APP_uploadurl
const uploadData = ref({key:"",Authorization:`Bearer ${getToken()}`})
const ruleFormRef = ref()
const saveLoading = ref(false)
const loading = ref(false)
const isSupperAdmin =  computed(()=>store.state.loginModel.isSupperAdmin)
// status:ready,success,error  {url:"https://cdn.brightstonecloud.com/qms/top-sum_dfc4ea70-bf0f-46b9-8967-d85161253356.png",status:"error"},
const fileList = ref([
  // {
  //   url:"https://cdn.brightstonecloud.com/qms/top-sum_dfc4ea70-bf0f-46b9-8967-d85161253356.png",
  //    status:"success",
  //   response:{
  //     data:"https://cdn.brightstonecloud.com/qms/top-sum_dfc4ea70-bf0f-46b9-8967-d85161253356.png",
  //     err_code:0,
  //   err_msg:"OK"
  //   }
  // },
]) // 照片上传
const form = reactive({
  Name: "", // 大赛名称
  Logo:"", // LOGO名称
  Time: [null,null], // 注册时间，表单用
  register_start: null, // 注册开始时间
  register_end: null,// 注册结束时间
  upload_end: null,// 截止时间
  finalTime: [null,null], // 复赛文件提交时间

})
const validateTime = (rule, value, callback)=>{
  if (value && value.length>1 && value[0] && value[1]) {
    callback()
  } else {
    callback(new Error("Two inputs don't match!"))
  }
}
const rules = ({
  name: [{required: true, message: '请输入大赛名称', trigger: ['blur']}],
  logo: [{required: true, message: '请上传大赛logo', trigger: [ 'blur']}],
  Time:[{required: true, message: '请选择可注册开放时间', trigger: ['blur']},{ validator: validateTime,message: '请选择可注册开放时间', trigger: 'blur' }],
  finalTime:[{required: true, message: '请选择复赛文件提交时间', trigger: ['blur']},{ validator: validateTime,message: '请选择复赛文件提交时间', trigger: 'blur' }],
  upload_end:[{required: true, message: '请选择选择文件截止上传时间', trigger: ['blur']}],
})

const dialogVisible = ref() // 照片
const dialogImageUrl = ref() //
onMounted(()=>{
  getInfo()
})
// 获取信息
const getInfo = async ()=>{
  loading.value = true
  const res = await getSettings({pageSize:10,current:1})
  if(res.success){
    loading.value = false
  //  获取配置信息
    const data = res.data || []
    data.forEach(item=>{
      if(item.KeyName === "name"){
        form.name = item.Value
      }
      if(item.KeyName === "logo"){
        form.nogo = item.Value
        fileList.value = [
          {
            url:item.Value,
             status:"success",
            response:{
              data:item.Value,
              err_code:0,
            err_msg:"OK"
            }
          },
        ]
      }
      // 注册时间
      if(item.KeyName === "register_start"){
        form.Time[0] = item.Value?formatTime(item.Value):null
      }
      if(item.KeyName === "register_end"){
        form.Time[1] = item.Value?formatTime(item.Value):null
      }
      // 复赛文件提交时间
      if(item.KeyName === "final_file_upload_start"){
        form.finalTime[0] = item.Value?formatTime(item.Value):null
      }
      if(item.KeyName === "final_file_upload_end"){
        form.finalTime[1] = item.Value?formatTime(item.Value):null
      }
      // 作品文件提交截止时间
      if(item.KeyName === "upload_end"){
        form.upload_end = item.Value?formatTime(item.Value):null
      }
    })
  }else{
    ElMessage.error("获取大赛信息失败")
  }
}

const save =async (ruleFormRef)=>{
  if(fileList.value && fileList.value.length>0){
    const item = fileList.value[0]
    if(item.response && item.response.err_code===0 && item.response.data){
      form.logo = item.response.data
    }
  }
  const isvalidate = await validateForm(ruleFormRef)
  if (!isvalidate) {
    return
  }
  const params = {
   ...form,
    register_start: form.Time[0],
    register_end: form.Time[1],
    final_file_upload_start: form.finalTime[0],
    final_file_upload_end: form.finalTime[1],
  }
  saveLoading.value = true
  const res =await updateAllSettings(params)
  saveLoading.value = false
  if(res.success){
    store.dispatch("sysModel/getAllsettingsFun") // 重新获取系统配置
    return ElMessage.success("保存成功")
  }else{
    ElMessage.success("保存失败")
  }

  console.log(params)

}
// 预览
const handlePictureCardPreview = (file) => {
  dialogImageUrl.value = file.url
      dialogVisible.value = true
}
const handleUploadExceed = ()=>{
  ElMessage.warning("只能上传一张logo")
}
// 失败
const handleUploadError = (res)=>{
  console.log(res)
  ElMessage.error("上传失败")
}
// 成功
const handleUploadSuccess = (res)=>{
  if(res.err_code===0 && res.data){
    // form.Link = res.data
  }else{
    return ElMessage.error("Logo上传失败")
  }
}
</script>

<style scoped lang="scss">

</style>
